import React from 'react'
import { FaRegPlayCircle } from "react-icons/fa";
import ModalSignupMember from '../modal/member/ModalSignupMember';
const MemberSignUpPage = () => {
  const bgImg = "https://images.pexels.com/photos/5063055/pexels-photo-5063055.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

  return (
    <div>
      <div className="container-fluid bg-offer my-5 py-5" style={{backgroundImage:`url('${bgImg}')`}}>
        <div className="container py-5">
          <div className="row gx-5 justify-content-start">
            <div className="col-lg-7">
              <div className="border-start border-5 border-dark ps-5 mb-5">
                <h6 className="text-dark text-uppercase text-gray-500 translatable">Bienvenue cher participant</h6>
                <h1 className="display-5 text-uppercase text-white mb-0 translatable">Devenir un membre pour une une plus forte influence</h1>
              </div>
              <p className="text-white mb-4 translatable">Votre soutien fait la fièrté de Christ dans sa Gloire</p>
              <button  className="btn btn-light py-md-3 px-md-5 me-3 translatable" data-bs-toggle="modal" data-bs-target="#member">Devenir Membre</button>

              <button type="button" className="btn-play" data-bs-toggle="modal" data-bs-target="#videoModal"
                data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" >
                <span></span>
              </button>

            </div>
          </div>
        </div>
      </div>
      {/* Video */}
      <div className="modal fade" id="videoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="ratio ratio-16x9">
              <iframe width="400" height="315" src="https://www.youtube.com/embed/Z3pMaZawpho?si=OgwKsRFa_p30qVQx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal Inscription */}
      <ModalSignupMember/>
      
      <div>
      </div>
    </div>
  )
}

export default MemberSignUpPage;